
import {
    useListLandscapeSavedSearches
} from './useListeningQueryPersistence.js';

import {
    listeningDefinitions
} from '../components/enums/listeningDefinitions.jsx';

const MAX_NAME_LENGTH = 30;

export default function useValidateSavedSearchName(savedSearchName, editingListeningQueryId) {

    const {data: allSavedSearches, isLoading: isLoadingAllSavedSearches} = useListLandscapeSavedSearches();

    const {
        emptyNameError,
        nameTooLongError,
        nameNotUniqueError
    } = listeningDefinitions['save-as-saved-search'];

    savedSearchName = (savedSearchName || '').trim();

    if (_.isEmpty(savedSearchName)) {
        return {
            error: emptyNameError
        };
    }

    if (savedSearchName.length >= MAX_NAME_LENGTH) {
        return {
            error: nameTooLongError(MAX_NAME_LENGTH)
        };
    }

    const conflictsWithOtherSavedSearch = _.find(allSavedSearches, savedSearch => {
        return savedSearch.id !== editingListeningQueryId && savedSearch.name.trim() === savedSearchName;
    });

    if (!isLoadingAllSavedSearches && conflictsWithOtherSavedSearch) {
        return {
            error: nameNotUniqueError
        };
    }
}
